/**
 * Error Message Component
 * Migrated to use cambrian-ds Button and design tokens
 */

import { Button } from "cambrian-ds";
import { AlertCircle } from 'lucide-react';
import { cn } from "@/lib/utils";
import { cambrianColors, typography } from "@/styles/design-tokens";

interface ErrorMessageProps {
  error: Error;
  retry?: () => void;
}

export function ErrorMessage({ error, retry }: ErrorMessageProps) {
  return (
    <div className="flex items-center justify-center h-64">
      <div className="text-center max-w-md">
        <div className={cn(
          "inline-flex items-center justify-center w-16 h-16 rounded-full mb-4",
          cambrianColors.status.error.bg,
          cambrianColors.status.error.text
        )}>
          <AlertCircle className="w-8 h-8" />
        </div>
        <h3 className={cn(typography.h4, cambrianColors.text.heading, "mb-2")}>
          Something went wrong
        </h3>
        <p className={cn(typography.body, cambrianColors.text.secondary, "mb-4")}>
          {error.message || 'An unexpected error occurred'}
        </p>
        {retry && (
          <Button
            onPress={retry}
            variant="primary"
            size="md"
          >
            Try Again
          </Button>
        )}
      </div>
    </div>
  );
}
